
export enum WsInEventEnum {
  Ping= 'Ping',
  Authorize= 'Authorize',
  Unauthorize= 'Unauthorize',
  ObserveAuctionListing= 'ObserveAuctionListing',
  ObserveAuctionDetail= 'ObserveAuctionDetail',
  ObserveDirectSalesListing= 'ObserveDirectSalesListing',
  ObserveDirectSaleDetail= 'ObserveDirectSaleDetail',

}